import { ChangeEventHandler, useCallback } from 'react';
import useStyles from './styles';
import React from 'react';
import { debounce } from 'lodash';
import { iconInfor2 } from 'assets/icons';
import { Tooltip } from '@material-ui/core';
import { RegisterOptions  } from 'react-hook-form';

interface ILabelInputProps {
  label: string;
  value?: string;
  onChange?: ChangeEventHandler | undefined;
  placeholder?: string;
  optional?: boolean;
  customClass?: string;
  name?: string;
  isPrice?: boolean;
  disable?: boolean;
  onBlur?: any;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  required?: boolean | string;
  errors?: any;
  tooltipComponent?: React.ReactNode;
  maxLength?: number,
  maxNumber?: number,
  isFullname?: any,
  isNumerical?: boolean,
  belowLabelComponent?: React.ReactNode,
  showErrors?: boolean,
  register?: ((val: string, val2: RegisterOptions) => {}) | ((val2: RegisterOptions) => {});
  cypressId?: string;
  inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
}

const LabelInput = React.forwardRef((props: ILabelInputProps, ref: any) => {
  const styles = useStyles();
  const {
    onChange,
    label,
    value,
    placeholder,
    optional,
    customClass,
    name,
    isPrice,
    disable,
    onBlur,
    onKeyDown,
    required,
    errors,
    tooltipComponent,
    maxLength,
    maxNumber,
    isFullname,
    isNumerical = false,
    register,
    showErrors,
    cypressId,
    inputMode
  } = props;

  const onKeyPressEvent = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const testStrValue = `${event?.target?.value}${keyValue}`;
    const countDot = testStrValue.length - testStrValue?.replaceAll('.','')?.length || 0;
    let maxLetNumber = maxNumber || 1000000;
    if(isPrice){
      if (!(new RegExp("[0-9.]").test(keyValue))){
        event.preventDefault();
      }else{
        if(countDot > 1){
          event.preventDefault();
        }else{
          if(parseFloat(testStrValue) >= maxLetNumber){
            event.preventDefault();
          }
        }
      }
    }
    if (isFullname) {
      if (
        (keyCode >= 33 && keyCode <= 47) || 
        (keyCode >= 48 && keyCode <= 57) || 
        (keyCode >= 58 && keyCode <= 64) || 
        (keyCode >= 91 && keyCode <= 96) || 
        (keyCode >= 123 && keyCode <= 126) 
      ) {
        event.preventDefault();
      }
    }
    return;
  }

  return (
    <div
      className={`${styles.container} ${customClass} ${disable && styles.disable
        } ${errors && styles.containerErr}`}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label className={styles.textLabel}>
          {label}
          {optional && (
            <label className={styles.textOptional}> · Optional</label>
          )}
        </label>
        {tooltipComponent && (
          <Tooltip
            placement='top'
            title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipComponent}</span>}
            classes={{
              tooltip: styles.tooltip,
              arrow: styles.popupTooltip,
            }}
          >
            <img src={iconInfor2} alt="tooltip icon" style={{ width: "15px", height: "15px" }} />
          </Tooltip>
        )}
      </div>
      { props?.belowLabelComponent ? props?.belowLabelComponent : null}
      <div className={styles.content}>
        {isPrice && <span className={styles.priceSymbol}>$</span>}
        {
          onChange ?  
            <input
            id='label-input'
            disabled={disable}
            ref={ref}
            className={styles.input}
            placeholder={placeholder || ''}
            value={value}
            name={name}
            onChange={onChange}
            {...register?.(name ? name : "", { required })}
            required={!!required}
            type={isNumerical ? "number" :'text'}
            maxLength={maxLength}
            onKeyPress={onKeyPressEvent}
            onKeyDown={onKeyDown}
            inputMode={inputMode}
            data-cy={cypressId}
          /> :  
          <input
            id='label-input'
            disabled={disable}
            ref={ref}
            className={styles.input}
            placeholder={placeholder || ''}
            value={value}
            name={name}
            
            {...register?.(name ? name : "", { required })}
            onBlur={onBlur || null}
            required={!!required}
            type={isNumerical ? "number" :'text'}
            maxLength={maxLength}
            onKeyPress={onKeyPressEvent}
            onKeyDown={onKeyDown}
            inputMode={inputMode}
            data-cy={cypressId}
          />
        }
        
      </div>
        {showErrors && errors && name && <p className={styles.errors}>{errors[name]?.message}</p>}
    </div>
  );
});

export default LabelInput;
